<template lang="pug">
  v-dialog(v-model="dialog",  persistent, max-width="300")
    template(v-slot:activator="{ on }")
      slot(name="btn", v-bind:on="on")
        v-btn(
          fab,
          x-small,
          absolute,
          top,
          right,
          color="error",
          v-on="on",
          style="right: 0"
        )
          v-icon mdi-delete    
    v-card
      v-card-title.headline {{ title }} it's going to be deleted
      v-card-text
        | Are you sure about deleting {{ title }}?
        | If you aren't sure about this action, we recommend to cancel now!!
      v-card-actions.pb-5.px-5
        v-spacer
        v-btn(color="primary", @click="dialog = false") Cancel
        v-btn(@click="confirm()") OK
</template>

<script>
export default {
  name: 'entity-delete',
  props: ['title'],
  data: () => ({
    dialog: false
  }),
  methods: {
    confirm () {
      this.dialog = false
      this.$emit('confirm')
    }
  }
}
</script>
